import axios from "axios";
import { getUserFromLS } from "../utils/getUserFromLS";
import { INSIGHT_STATUS } from "../Types/account";

interface UpdateInsightStatusParams {
  insight_type:
    | "ACCOUNT_INSIGHT"
    | "INDUSTRY_INSIGHT"
    | "CONTACT_INTELLIGENCE"
    | "SOCIAL_PROMPT"
    | "ASSET_INSIGHT";
  insight_id: number;
  new_status: INSIGHT_STATUS;
  number_of_emails?: number | null;
  number_of_calls?: number | null;
  number_of_linkedin_dms?: number | null;
  comments?: string | null;
  account_id?: string | null;
  contact_id?: number | null;
  favorite?: boolean | null;
  index?: number | null;
  notes?: string | null;
}

export const updateInsightStatus = (
  params: UpdateInsightStatusParams,
  callback: () => void,
  errorCallback: (error: any) => void
) => {
  const requestBody: any = {
    insight_type: params.insight_type,
    insight_id: params.insight_id,
    new_status: params.new_status,
  };

  // Only add optional fields if they are not null or undefined
  if (params.account_id !== null && params.account_id !== undefined) {
    requestBody.account_id = params.account_id;
  }

  if (params.contact_id !== null && params.contact_id !== undefined) {
    requestBody.contact_id = params.contact_id;
  }

  if (
    params.number_of_emails !== null &&
    params.number_of_emails !== undefined
  ) {
    requestBody.number_of_emails = params.number_of_emails;
  }

  if (params.number_of_calls !== null && params.number_of_calls !== undefined) {
    requestBody.number_of_calls = params.number_of_calls;
  }

  if (
    params.number_of_linkedin_dms !== null &&
    params.number_of_linkedin_dms !== undefined
  ) {
    requestBody.number_of_linkedin_dms = params.number_of_linkedin_dms;
  }

  if (params.comments !== null && params.comments !== undefined) {
    requestBody.comments = params.comments;
  }

  if (params.favorite !== null && params.favorite !== undefined) {
    requestBody.favorite = params.favorite;
  }

  if (params.index !== null && params.index !== undefined) {
    requestBody.index = params.index;
  }

  if (params.notes !== null && params.notes !== undefined) {
    requestBody.notes = params.notes;
  }

  const token = getUserFromLS().access_token;
  const URL = `${import.meta.env.VITE_API_BASE_URL}/status/`;

  return axios(URL, {
    method: "PUT",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    data: requestBody,
  })
    .then((response) => {
      callback();
    })
    .catch((error) => {
      console.error("Error updating insight status:", error);
      errorCallback(error);
    });
};
